import React, { useState } from 'react';
import './PostActionButtons.scss';
import AskRemoveModal from './AskRemoveModal';

const ActionButton = React.memo(({ children, ...rest }) => (
  <button className="ActionButton" {...rest}>
    {children}
  </button>
));

const PostActionButtons = ({ onEdit, onRemove }) => {
  const [modal, setModal] = useState(false);
  const onRemoveClick = () => {
    setModal(true);
  };

  const onCancel = () => {
    setModal(false);
  };

  const onConfirm = () => {
    setModal(false);
    onRemove();
  };

  return (
    <>
      <div className="PostActionButtons">
        <ActionButton onClick={onEdit}>수정</ActionButton>
        <ActionButton onClick={onRemoveClick}>삭제</ActionButton>
      </div>
      <AskRemoveModal
        visible={modal}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </>
  );
};

export default PostActionButtons;
